










































import { mapGetters, mapActions } from 'vuex'
import BankNavbar from '@/components/BankNavbar.vue'
import CustomerModal from '@/components/CustomerModal.vue'

export default {
  name: 'BankDashboard',
  components: {
    BankNavbar,
    CustomerModal
  },
  data () {
    return {
      customerList: []
    }
  },
  computed: {
    ...mapGetters([
      'sessionUser',
      'currentBank',
      'currentYear',
      'lastYear',
      'riskLevels',
      'riskLevelClasses'
    ])
  },
  methods: {
    ...mapActions([
      'loadBank',
      'getBankCustomers'
    ]),

    async loadCustomers () {
      const result = await this.getBankCustomers()
      console.log('  loadCustomers result', result)
      if (result.success) {
        this.customerList = result.data
      }
    },

    newCustomer () {
      this.$refs.customerModal.show({bank_id: this.currentBankId})
    },

    editCustomer (customer: Customer) {
      this.$refs.customerModal.loadAndShow(customer)
    },

    riskBadgeOfCustomerSubForYear (cust: Customer, year: string) {
      if (cust.hasOwnProperty('submissions') && Array.isArray(cust.submissions)) {
        for (let s=0, l=cust.submissions.length; s<l; s++) {
          if (cust.submissions[s].period == year) {
            return `<span class="badge badge-${this.riskLevelClasses[cust.submissions[s].overall_risk]}">${this.riskLevels[cust.submissions[s].overall_risk]} Risk</span>`
          }
        }
      }
      return '<em>Incomplete</em>'
    },

    riskOfCustomerSubForYear (cust: Customer, year: string) {
      if (cust.hasOwnProperty('submissions') && Array.isArray(cust.submissions)) {
        for (let s=0, l=cust.submissions.length; s<l; s++) {
          if (cust.submissions[s].period == year) return this.riskLevels[cust.submissions[s].overall_risk]
        }
      }
      return '--'
    }

  },
  async mounted () {
    console.log('BankDashboard.mounted')
    console.log('  sessionUser', this.sessionUser)
    this.loadBank(this.sessionUser.bank_id)
    // this.customerList = await this.getBankCustomers(this.sessionUser.bank_id)
    this.loadCustomers()
  }
}
